import React from 'react'

const SupportUs = () => {
    return (
        <div className='d-flex justify-content-center flex-column align-items-center p-4 pb-5'>
            <h2 className='mt-2'>Liked the project? </h2>
            <a rel="noreferrer"  href="https://www.producthunt.com/posts/notion-diary?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-notion-diary" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=324601&theme=light" alt="Notion Diary - Bootstraps your notion pages to a blogsite. | Product Hunt"  width="250" height="54" /></a>
        </div>
    )
}

export default SupportUs
